<template>
    <div>
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="669.7px"
	 height="386.1px" viewBox="0 0 669.7 386.1" style="enable-background:new 0 0 669.7 386.1;" xml:space="preserve">
<g id="pantalla_5">
	<g id="XMLID_374_">
		<path id="XMLID_377_" d="M307.5,145.3l-3.8-10.5l1.9-0.7l3.2,8.9l4.3-1.6l0.6,1.6L307.5,145.3z"/>
		<path id="XMLID_390_" d="M316.5,142.3c-0.3,0.1-0.7,0.1-1,0c-0.3-0.2-0.5-0.4-0.7-0.8c-0.1-0.4-0.1-0.7,0-1
			c0.1-0.3,0.4-0.5,0.7-0.7c0.3-0.1,0.7-0.1,1,0c0.3,0.2,0.5,0.4,0.7,0.8c0.1,0.4,0.1,0.7,0,1S316.9,142.2,316.5,142.3z"/>
		<path id="XMLID_394_" d="M323.1,139.9c-0.7,0.3-1.4,0.4-2.2,0.3c-0.8,0-1.5-0.2-2.1-0.5l0.6-1.7c0.5,0.2,1,0.3,1.6,0.4
			c0.6,0,1.1,0,1.6-0.2c0.6-0.2,1-0.5,1.2-0.9c0.2-0.4,0.3-0.7,0.1-1.1c-0.1-0.2-0.2-0.4-0.3-0.5c-0.1-0.1-0.3-0.2-0.5-0.3
			c-0.2-0.1-0.4-0.1-0.6-0.1c-0.2,0-0.5,0-0.8-0.1l-1.7-0.1c-0.3,0-0.6-0.1-0.9-0.1c-0.3-0.1-0.6-0.2-0.9-0.3s-0.5-0.4-0.8-0.6
			c-0.2-0.3-0.4-0.6-0.6-1c-0.2-0.4-0.2-0.8-0.2-1.3c0-0.4,0.2-0.8,0.4-1.2s0.5-0.7,0.9-1c0.4-0.3,0.8-0.6,1.3-0.7
			c0.6-0.2,1.2-0.3,1.9-0.3c0.7,0,1.3,0.2,1.8,0.4l-0.5,1.5c-0.4-0.2-0.9-0.2-1.3-0.3c-0.4,0-0.9,0-1.3,0.2
			c-0.5,0.2-0.9,0.4-1.1,0.8c-0.2,0.3-0.3,0.7-0.1,1.1c0.1,0.2,0.2,0.4,0.3,0.5c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.4,0.1,0.6,0.1
			c0.2,0,0.5,0,0.7,0l1.6,0.1c0.4,0,0.7,0.1,1,0.1c0.3,0.1,0.6,0.2,0.9,0.4c0.3,0.2,0.5,0.4,0.7,0.6c0.2,0.3,0.4,0.6,0.5,1
			c0.2,0.4,0.2,0.9,0.2,1.3c0,0.4-0.2,0.9-0.4,1.3c-0.2,0.4-0.5,0.8-0.9,1.1C324.2,139.4,323.7,139.7,323.1,139.9z"/>
		<path id="XMLID_413_" d="M329.6,137.6c-0.3,0.1-0.7,0.1-1,0s-0.5-0.4-0.7-0.8c-0.1-0.4-0.1-0.7,0-1c0.1-0.3,0.4-0.5,0.7-0.7
			c0.3-0.1,0.7-0.1,1,0c0.3,0.2,0.5,0.4,0.7,0.8c0.1,0.4,0.1,0.7,0,1S330,137.4,329.6,137.6z"/>
		<path id="XMLID_417_" d="M333.1,136.1l-3.8-10.5l1.9-0.7l3.8,10.5L333.1,136.1z"/>
		<path id="XMLID_419_" d="M338.5,134.3c-0.3,0.1-0.7,0.1-1,0c-0.3-0.2-0.5-0.4-0.7-0.8c-0.1-0.4-0.1-0.7,0-1
			c0.1-0.3,0.4-0.5,0.7-0.7c0.3-0.1,0.7-0.1,1,0c0.3,0.2,0.5,0.4,0.7,0.8c0.1,0.4,0.1,0.7,0,1C339.1,134,338.9,134.2,338.5,134.3z"
			/>
	</g>
	
		<linearGradient id="XMLID_62_" gradientUnits="userSpaceOnUse" x1="259.4033" y1="-17268.082" x2="495.6185" y2="-17055.3711" gradientTransform="matrix(1 0 0 -1 0 -16933.5645)">
		<stop  offset="0" style="stop-color:#FFE888"/>
		<stop  offset="0.9789" style="stop-color:#FFA370"/>
	</linearGradient>
	<polygon id="XMLID_315_" class="st185" points="464.8,89.7 250,172.3 231.8,285.2 464.8,320.2 	"/>
	
		<linearGradient id="XMLID_107_" gradientUnits="userSpaceOnUse" x1="427.8389" y1="-17214.5039" x2="503.8384" y2="-17003.8379" gradientTransform="matrix(1 0 0 -1 0 -16933.5645)">
		<stop  offset="0" style="stop-color:#F9385D"/>
		<stop  offset="1" style="stop-color:#B52B3A"/>
	</linearGradient>
	<path id="XMLID_322_" class="st267" d="M431.2,137.1c-2.5,4.2-4.6,8.6-6.6,13c-2,4.5-3.8,8.9-4.5,13.7c-0.8,4.8-0.9,9.8-1.4,14.6
		c-0.5,5-4.7,85.7,1.5,98.5c2,4.1,4.1,8,7.3,11.2c1.6,1.5,35.4,29.1,37.3,30.7V89.7C464.8,89.7,436.1,128.8,431.2,137.1z"/>
	<line id="XMLID_313_" class="st303" x1="416.9" y1="338.2" x2="416.9" y2="203"/>
	<line id="XMLID_316_" class="st247" x1="248.7" y1="95.2" x2="225" y2="320.2"/>
	<polyline id="XMLID_319_" class="st247" points="190.1,338.2 225,320.2 266.3,75.6 	"/>
	<line id="XMLID_317_" class="st247" x1="231.8" y1="285.2" x2="261.3" y2="338.2"/>
	<g id="XMLID_382_">
		<polyline id="XMLID_314_" class="st115" points="202.3,67.2 202.3,320.2 512.3,320.2 		"/>
		<polyline id="XMLID_381_" class="st115" points="198.3,70.9 202.4,65.4 206.4,70.9 		"/>
		<polyline id="XMLID_401_" class="st115" points="508.4,316.2 513.9,320.3 508.4,324.3 		"/>
	</g>
	<g id="XMLID_403_">
		<rect id="XMLID_563_" x="167.4" y="17.3" class="st227" width="324" height="18"/>
		<text transform="matrix(1 0 0 1 211.4614 32.0127)" class="st8 st278">Límites de inflamabilidad</text>
	</g>
	
		<linearGradient id="XMLID_109_" gradientUnits="userSpaceOnUse" x1="331.1851" y1="-17252.1133" x2="385.1855" y2="-17252.1133" gradientTransform="matrix(1 0 0 -1 0 -16933.5645)">
		<stop  offset="0" style="stop-color:#C7EE95"/>
		<stop  offset="1" style="stop-color:#9BE89F"/>
	</linearGradient>
	
		<circle id="XMLID_318_" style="fill:none;stroke:url(#XMLID_109_);stroke-width:4;stroke-miterlimit:10;" cx="358.2" cy="318.6" r="25"/>
	
		<linearGradient id="XMLID_110_" gradientUnits="userSpaceOnUse" x1="346.6021" y1="-17241.9492" x2="369.7686" y2="-17241.9492" gradientTransform="matrix(1 0 0 -1 0 -16933.5645)">
		<stop  offset="0" style="stop-color:#C7EE95"/>
		<stop  offset="1" style="stop-color:#9BE89F"/>
	</linearGradient>
	<polygon id="XMLID_98_" class="st269" points="359.9,319.1 359.9,314.4 363.6,319.1 363.6,312.7 368.8,314.4 364.4,310.7 
		369.8,309.4 364.9,307.2 367.8,304.6 363.1,304.6 364.9,299.6 360.6,304.1 359.9,297.7 357.6,303.7 354.8,298.6 354.8,304.1 
		350.4,300.2 352.4,304.9 346.6,308.4 353.4,308.4 349.3,311.9 353.4,312.6 350.6,316.4 356.4,315.2 354.9,319.1 358.2,315.7 	"/>
	<g id="XMLID_108_">
		<rect id="XMLID_599_" x="222.8" y="47.9" class="st227" width="213.1" height="16.2"/>
		<text transform="matrix(1 0 0 1 228.7144 59.9482)" class="st305 st104 st277">Sin llama / Riesgo de asfixia</text>
	</g>
	<g id="XMLID_215_">
		<rect id="XMLID_759_" x="203.5" y="81.6" class="st227" width="57.8" height="12.2"/>
		<text transform="matrix(1 0 0 1 206.625 92.8467)" class="st305 st104 st276">Liquida</text>
	</g>
	<g id="XMLID_217_">
		<rect id="XMLID_760_" x="268.2" y="92.4" class="st227" width="61.6" height="12.8"/>
		<text transform="matrix(1 0 0 1 270.417 103.6807)" class="st305 st104 st276">Gaseosa</text>
	</g>
	<g id="XMLID_8_">
		<rect id="XMLID_762_" x="263.3" y="203.9" class="st227" width="116.7" height="31.7"/>
		<text transform="matrix(1 0 0 1 287.6274 215.9287)"><tspan x="0" y="0" class="st305 st104 st277">Rango de </tspan><tspan x="-19.4" y="17" class="st305 st104 st277">inflamabilidad</tspan></text>
	</g>
	<g id="XMLID_11_">
		<rect id="XMLID_987_" x="472" y="198.1" class="st227" width="100.3" height="15.8"/>
		<text transform="matrix(1 0 0 1 475.7656 210.0537)" class="st104 st277">Autoignición</text>
	</g>
	
		<linearGradient id="XMLID_111_" gradientUnits="userSpaceOnUse" x1="464.8496" y1="-17075.0313" x2="488.1826" y2="-17075.0313" gradientTransform="matrix(1 0 0 -1 0 -16933.5645)">
		<stop  offset="0" style="stop-color:#F9385D"/>
		<stop  offset="1" style="stop-color:#B52B3A"/>
	</linearGradient>
	<polyline id="XMLID_18_" style="fill:none;stroke:url(#XMLID_111_);stroke-miterlimit:10;" points="464.8,89.7 487.7,89.7 
		487.7,193.7 	"/>
	
		<linearGradient id="XMLID_112_" gradientUnits="userSpaceOnUse" x1="464.8496" y1="117.5342" x2="488.1826" y2="117.5342" gradientTransform="matrix(1 0 0 -1 0 384.0801)">
		<stop  offset="0" style="stop-color:#F9385D"/>
		<stop  offset="1" style="stop-color:#B52B3A"/>
	</linearGradient>
	<polyline id="XMLID_19_" style="fill:none;stroke:url(#XMLID_112_);stroke-miterlimit:10;" points="464.8,318.3 487.7,318.3 
		487.7,214.3 	"/>
	<g id="XMLID_44_">
		<g id="XMLID_862_">
			<path id="XMLID_963_" class="st305" d="M195.2,290.3c0,0.6-0.1,1.2-0.3,1.7c-0.2,0.5-0.5,1-1,1.4c-0.4,0.4-1,0.7-1.6,0.9
				c-0.6,0.2-1.3,0.3-2.1,0.3c-0.8,0-1.5-0.1-2.1-0.4c-0.6-0.2-1.2-0.6-1.6-1c-0.4-0.4-0.8-0.9-1-1.4c-0.2-0.5-0.3-1.1-0.3-1.7
				s0.1-1.2,0.4-1.6c0.2-0.5,0.5-0.9,0.9-1.2l1.1,0.9c-0.3,0.3-0.5,0.5-0.6,0.8c-0.2,0.3-0.2,0.6-0.2,1c0,0.4,0.1,0.8,0.2,1.1
				c0.2,0.3,0.4,0.6,0.7,0.9c0.3,0.2,0.7,0.4,1.1,0.6c0.4,0.1,0.9,0.2,1.5,0.2c1.1,0,2-0.2,2.6-0.7c0.6-0.5,0.9-1.1,0.9-2
				c0-0.4-0.1-0.8-0.3-1.2c-0.2-0.3-0.4-0.6-0.7-0.9l1.1-0.9c0.5,0.4,0.8,0.9,1.1,1.4C195.1,289.1,195.2,289.7,195.2,290.3z"/>
			<path id="XMLID_958_" class="st305" d="M195.2,282.7c0,0.5-0.1,0.9-0.3,1.3s-0.4,0.8-0.7,1.1c-0.3,0.3-0.7,0.6-1.2,0.8
				c-0.5,0.2-1,0.3-1.6,0.3c-0.6,0-1.1-0.1-1.6-0.3c-0.5-0.2-0.9-0.4-1.2-0.8c-0.3-0.3-0.6-0.7-0.8-1.1c-0.2-0.4-0.3-0.9-0.3-1.3
				s0.1-0.9,0.3-1.3c0.2-0.4,0.4-0.8,0.8-1.1c0.3-0.3,0.7-0.6,1.2-0.8s1-0.3,1.6-0.3c0.6,0,1.1,0.1,1.6,0.3c0.5,0.2,0.9,0.5,1.2,0.8
				s0.6,0.7,0.7,1.1S195.2,282.3,195.2,282.7z M193.8,282.7c0-0.5-0.2-1-0.7-1.3c-0.4-0.3-1-0.5-1.8-0.5c-0.7,0-1.3,0.2-1.8,0.5
				c-0.4,0.3-0.7,0.7-0.7,1.3s0.2,1,0.7,1.3c0.4,0.3,1,0.5,1.8,0.5c0.7,0,1.3-0.2,1.8-0.5C193.6,283.7,193.8,283.3,193.8,282.7z"/>
			<path id="XMLID_955_" class="st305" d="M195,277.5h-7.3v-1.4l1-0.1V276c-0.3-0.3-0.6-0.7-0.8-1.1c-0.2-0.4-0.3-0.8-0.3-1.3
				c0-0.8,0.3-1.4,0.8-1.7c0.5-0.4,1.2-0.5,2.2-0.5h4.6v1.7h-4.4c-0.6,0-1,0.1-1.3,0.3c-0.2,0.2-0.4,0.5-0.4,0.9
				c0,0.3,0.1,0.6,0.2,0.8c0.2,0.2,0.4,0.5,0.7,0.8h5.1V277.5z"/>
			<path id="XMLID_953_" class="st305" d="M195.2,266.1c0,0.5-0.1,1-0.3,1.4s-0.4,0.8-0.7,1.1s-0.7,0.6-1.2,0.7
				c-0.5,0.2-1,0.3-1.6,0.3c-0.6,0-1.1-0.1-1.6-0.3c-0.5-0.2-0.9-0.5-1.2-0.8c-0.3-0.3-0.6-0.7-0.8-1.2c-0.2-0.4-0.3-0.9-0.3-1.4
				c0-0.5,0.1-0.9,0.2-1.2c0.2-0.3,0.4-0.6,0.6-0.9l1.1,0.8c-0.2,0.2-0.3,0.4-0.4,0.6c-0.1,0.2-0.1,0.4-0.1,0.6
				c0,0.6,0.2,1.1,0.7,1.4c0.4,0.4,1,0.6,1.8,0.6c0.7,0,1.3-0.2,1.8-0.5c0.4-0.4,0.7-0.8,0.7-1.4c0-0.3-0.1-0.6-0.2-0.8
				c-0.1-0.3-0.3-0.5-0.4-0.7l1.1-0.7c0.3,0.3,0.5,0.7,0.7,1.1C195.1,265.3,195.2,265.7,195.2,266.1z"/>
			<path id="XMLID_949_" class="st305" d="M195.2,259.5c0,0.5-0.1,1-0.3,1.4s-0.4,0.8-0.8,1.1c-0.3,0.3-0.7,0.6-1.2,0.8
				c-0.5,0.2-1,0.3-1.6,0.3c-0.6,0-1.1-0.1-1.6-0.3c-0.5-0.2-0.9-0.4-1.2-0.8c-0.3-0.3-0.6-0.7-0.8-1.1c-0.2-0.4-0.3-0.8-0.3-1.3
				c0-0.5,0.1-0.9,0.3-1.3c0.2-0.4,0.4-0.7,0.7-0.9c0.3-0.3,0.7-0.4,1.1-0.6c0.4-0.1,0.9-0.2,1.4-0.2c0.2,0,0.3,0,0.5,0
				c0.1,0,0.3,0,0.4,0.1v4.7c0.7-0.1,1.2-0.3,1.5-0.7s0.5-0.9,0.5-1.5c0-0.3,0-0.6-0.1-0.9c-0.1-0.3-0.2-0.5-0.4-0.8l1.1-0.6
				c0.2,0.3,0.4,0.7,0.6,1.2C195.1,258.6,195.2,259.1,195.2,259.5z M190.7,261.5v-3.3c-0.6,0-1,0.1-1.3,0.4
				c-0.3,0.2-0.5,0.6-0.5,1.1c0,0.4,0.2,0.8,0.5,1.1C189.6,261.2,190.1,261.4,190.7,261.5z"/>
			<path id="XMLID_946_" class="st305" d="M195,255.1h-7.3v-1.4l1-0.1v-0.1c-0.3-0.3-0.6-0.7-0.8-1.1c-0.2-0.4-0.3-0.8-0.3-1.3
				c0-0.8,0.3-1.4,0.8-1.7c0.5-0.4,1.2-0.5,2.2-0.5h4.6v1.7h-4.4c-0.6,0-1,0.1-1.3,0.3c-0.2,0.2-0.4,0.5-0.4,0.9
				c0,0.3,0.1,0.6,0.2,0.8c0.2,0.2,0.4,0.5,0.7,0.8h5.1V255.1z"/>
			<path id="XMLID_943_" class="st305" d="M195.2,244.2c0,0.4-0.1,0.8-0.2,1.1c-0.1,0.3-0.3,0.5-0.5,0.7c-0.2,0.2-0.5,0.3-0.8,0.4
				c-0.3,0.1-0.7,0.1-1.1,0.1h-3.5v1h-1.3l-0.1-1.1l-2-0.2v-1.4h2v-1.9h1.4v1.9h3.5c0.9,0,1.3-0.3,1.3-1c0-0.1,0-0.3,0-0.4
				c0-0.1-0.1-0.3-0.1-0.4l1.3-0.3c0.1,0.2,0.1,0.4,0.2,0.7C195.2,243.6,195.2,243.9,195.2,244.2z"/>
			<path id="XMLID_937_" class="st305" d="M195,241.4h-7.3v-1.4l1.3-0.1v-0.1c-0.5-0.3-0.8-0.6-1.1-0.9c-0.3-0.4-0.4-0.7-0.4-1.1
				c0-0.3,0-0.6,0.1-0.8l1.5,0.3c0,0.1-0.1,0.2-0.1,0.4c0,0.1,0,0.2,0,0.4c0,0.3,0.1,0.6,0.3,0.9c0.2,0.3,0.6,0.6,1.2,0.8h4.5V241.4
				z"/>
			<path id="XMLID_920_" class="st305" d="M195.2,234.4c0,0.6-0.2,1.2-0.6,1.6c-0.4,0.4-0.9,0.6-1.6,0.6c-0.4,0-0.7-0.1-1-0.2
				c-0.3-0.2-0.6-0.4-0.8-0.8c-0.2-0.4-0.4-0.8-0.6-1.3c-0.1-0.5-0.3-1.2-0.3-1.9c-0.2,0-0.4,0-0.5,0.1c-0.2,0-0.3,0.1-0.5,0.2
				c-0.1,0.1-0.2,0.2-0.3,0.4s-0.1,0.4-0.1,0.6c0,0.4,0.1,0.7,0.2,1.1c0.1,0.3,0.3,0.7,0.5,1l-1.1,0.6c-0.3-0.4-0.5-0.9-0.7-1.4
				c-0.2-0.5-0.3-1.1-0.3-1.6c0-0.9,0.3-1.6,0.8-2.1c0.5-0.5,1.3-0.7,2.3-0.7h4.3v1.4l-0.8,0.1v0.1c0.3,0.3,0.5,0.7,0.7,1.1
				C195.1,233.6,195.2,234,195.2,234.4z M193.9,233.8c0-0.3-0.1-0.6-0.2-0.8c-0.1-0.2-0.3-0.5-0.6-0.8h-1.6c0.1,0.5,0.1,0.9,0.2,1.3
				c0.1,0.3,0.2,0.6,0.3,0.8c0.1,0.2,0.3,0.4,0.4,0.4c0.2,0.1,0.3,0.1,0.5,0.1c0.3,0,0.6-0.1,0.7-0.3S193.9,234.2,193.9,233.8z"/>
			<path id="XMLID_917_" class="st305" d="M195.2,225.4c0,0.5-0.1,1-0.3,1.4c-0.2,0.4-0.4,0.8-0.7,1.1s-0.7,0.6-1.2,0.7
				c-0.5,0.2-1,0.3-1.6,0.3c-0.6,0-1.1-0.1-1.6-0.3c-0.5-0.2-0.9-0.5-1.2-0.8c-0.3-0.3-0.6-0.7-0.8-1.2c-0.2-0.4-0.3-0.9-0.3-1.4
				c0-0.5,0.1-0.9,0.2-1.2c0.2-0.3,0.4-0.6,0.6-0.9l1.1,0.8c-0.2,0.2-0.3,0.4-0.4,0.6c-0.1,0.2-0.1,0.4-0.1,0.6
				c0,0.6,0.2,1.1,0.7,1.4c0.4,0.4,1,0.6,1.8,0.6c0.7,0,1.3-0.2,1.8-0.5c0.4-0.4,0.7-0.8,0.7-1.4c0-0.3-0.1-0.6-0.2-0.8
				c-0.1-0.3-0.3-0.5-0.4-0.7l1.1-0.7c0.3,0.3,0.5,0.7,0.7,1.1C195.1,224.6,195.2,225,195.2,225.4z"/>
			<path id="XMLID_914_" class="st305" d="M186.4,220.7c0,0.3-0.1,0.6-0.3,0.8c-0.2,0.2-0.4,0.3-0.7,0.3c-0.3,0-0.5-0.1-0.7-0.3
				c-0.2-0.2-0.3-0.5-0.3-0.8s0.1-0.6,0.3-0.8c0.2-0.2,0.4-0.3,0.7-0.3c0.3,0,0.5,0.1,0.7,0.3S186.4,220.4,186.4,220.7z M195,221.6
				h-7.3v-1.7h7.3V221.6z"/>
			<path id="XMLID_904_" class="st305" d="M195.2,214.7c0,0.5-0.1,0.9-0.3,1.3s-0.4,0.8-0.7,1.1s-0.7,0.6-1.2,0.8
				c-0.5,0.2-1,0.3-1.6,0.3c-0.6,0-1.1-0.1-1.6-0.3c-0.5-0.2-0.9-0.4-1.2-0.8c-0.3-0.3-0.6-0.7-0.8-1.1c-0.2-0.4-0.3-0.9-0.3-1.3
				c0-0.5,0.1-0.9,0.3-1.3c0.2-0.4,0.4-0.8,0.8-1.1c0.3-0.3,0.7-0.6,1.2-0.8c0.5-0.2,1-0.3,1.6-0.3c0.6,0,1.1,0.1,1.6,0.3
				c0.5,0.2,0.9,0.5,1.2,0.8c0.3,0.3,0.6,0.7,0.7,1.1C195.1,213.8,195.2,214.2,195.2,214.7z M193.8,214.7c0-0.5-0.2-1-0.7-1.3
				c-0.4-0.3-1-0.5-1.8-0.5c-0.7,0-1.3,0.2-1.8,0.5c-0.4,0.3-0.7,0.7-0.7,1.3c0,0.5,0.2,1,0.7,1.3c0.4,0.3,1,0.5,1.8,0.5
				c0.7,0,1.3-0.2,1.8-0.5C193.6,215.6,193.8,215.2,193.8,214.7z M186.5,214.7l-0.9,0.9l-2.6-2.2l1.1-1.2L186.5,214.7z"/>
			<path id="XMLID_900_" class="st305" d="M195,209.5h-7.3v-1.4l1-0.1v-0.1c-0.3-0.3-0.6-0.7-0.8-1.1c-0.2-0.4-0.3-0.8-0.3-1.3
				c0-0.8,0.3-1.4,0.8-1.7c0.5-0.4,1.2-0.5,2.2-0.5h4.6v1.7h-4.4c-0.6,0-1,0.1-1.3,0.3c-0.2,0.2-0.4,0.5-0.4,0.9
				c0,0.3,0.1,0.6,0.2,0.8c0.2,0.2,0.4,0.5,0.7,0.8h5.1V209.5z"/>
			<path id="XMLID_894_" class="st305" d="M195.2,195.6c0,0.9-0.3,1.7-1,2.2c-0.7,0.5-1.6,0.8-2.8,0.8c-0.6,0-1.1-0.1-1.6-0.3
				c-0.5-0.2-0.9-0.4-1.2-0.7s-0.6-0.6-0.8-1c-0.2-0.4-0.3-0.8-0.3-1.2c0-0.4,0.1-0.8,0.2-1.1c0.1-0.3,0.3-0.6,0.6-0.9l-1.2,0.1
				h-2.7v-1.7H195v1.4l-0.8,0.1v0.1c0.3,0.3,0.5,0.6,0.7,0.9C195.1,194.8,195.2,195.2,195.2,195.6z M193.8,195.2
				c0-0.5-0.3-1.1-0.8-1.5h-3.4c-0.2,0.3-0.4,0.5-0.5,0.8c-0.1,0.2-0.1,0.5-0.1,0.7c0,0.5,0.2,0.9,0.6,1.2c0.4,0.3,1,0.5,1.8,0.5
				c0.8,0,1.4-0.1,1.8-0.4C193.6,196.1,193.8,195.7,193.8,195.2z"/>
			<path id="XMLID_891_" class="st305" d="M195.2,186.6c0,0.5-0.1,1-0.3,1.4s-0.4,0.8-0.8,1.1c-0.3,0.3-0.7,0.6-1.2,0.8
				c-0.5,0.2-1,0.3-1.6,0.3c-0.6,0-1.1-0.1-1.6-0.3c-0.5-0.2-0.9-0.4-1.2-0.8c-0.3-0.3-0.6-0.7-0.8-1.1c-0.2-0.4-0.3-0.8-0.3-1.3
				c0-0.5,0.1-0.9,0.3-1.3c0.2-0.4,0.4-0.7,0.7-0.9c0.3-0.3,0.7-0.4,1.1-0.6c0.4-0.1,0.9-0.2,1.4-0.2c0.2,0,0.3,0,0.5,0
				c0.1,0,0.3,0,0.4,0.1v4.7c0.7-0.1,1.2-0.3,1.5-0.7s0.5-0.9,0.5-1.5c0-0.3,0-0.6-0.1-0.9c-0.1-0.3-0.2-0.5-0.4-0.8l1.1-0.6
				c0.2,0.3,0.4,0.7,0.6,1.2C195.1,185.7,195.2,186.1,195.2,186.6z M190.7,188.6v-3.3c-0.6,0-1,0.1-1.3,0.4
				c-0.3,0.2-0.5,0.6-0.5,1.1c0,0.4,0.2,0.8,0.5,1.1S190.1,188.5,190.7,188.6z"/>
			<path id="XMLID_889_" class="st305" d="M195.2,176.1c0,0.5-0.1,1-0.3,1.4s-0.4,0.8-0.7,1.1s-0.7,0.6-1.2,0.7
				c-0.5,0.2-1,0.3-1.6,0.3c-0.6,0-1.1-0.1-1.6-0.3s-0.9-0.5-1.2-0.8c-0.3-0.3-0.6-0.7-0.8-1.2c-0.2-0.4-0.3-0.9-0.3-1.4
				c0-0.5,0.1-0.9,0.2-1.2c0.2-0.3,0.4-0.6,0.6-0.9l1.1,0.8c-0.2,0.2-0.3,0.4-0.4,0.6c-0.1,0.2-0.1,0.4-0.1,0.6
				c0,0.6,0.2,1.1,0.7,1.4c0.4,0.4,1,0.6,1.8,0.6c0.7,0,1.3-0.2,1.8-0.5c0.4-0.4,0.7-0.8,0.7-1.4c0-0.3-0.1-0.6-0.2-0.8
				c-0.1-0.3-0.3-0.5-0.4-0.7l1.1-0.7c0.3,0.3,0.5,0.7,0.7,1.1C195.1,175.3,195.2,175.7,195.2,176.1z"/>
			<path id="XMLID_886_" class="st305" d="M195.2,169.7c0,0.5-0.1,0.9-0.3,1.3c-0.2,0.4-0.4,0.8-0.7,1.1s-0.7,0.6-1.2,0.8
				c-0.5,0.2-1,0.3-1.6,0.3c-0.6,0-1.1-0.1-1.6-0.3c-0.5-0.2-0.9-0.4-1.2-0.8c-0.3-0.3-0.6-0.7-0.8-1.1c-0.2-0.4-0.3-0.9-0.3-1.3
				c0-0.5,0.1-0.9,0.3-1.3c0.2-0.4,0.4-0.8,0.8-1.1c0.3-0.3,0.7-0.6,1.2-0.8c0.5-0.2,1-0.3,1.6-0.3c0.6,0,1.1,0.1,1.6,0.3
				c0.5,0.2,0.9,0.5,1.2,0.8s0.6,0.7,0.7,1.1S195.2,169.2,195.2,169.7z M193.8,169.7c0-0.5-0.2-1-0.7-1.3c-0.4-0.3-1-0.5-1.8-0.5
				c-0.7,0-1.3,0.2-1.8,0.5c-0.4,0.3-0.7,0.7-0.7,1.3s0.2,1,0.7,1.3c0.4,0.3,1,0.5,1.8,0.5c0.7,0,1.3-0.2,1.8-0.5
				C193.6,170.6,193.8,170.2,193.8,169.7z"/>
			<path id="XMLID_884_" class="st305" d="M195,164.5h-7.3V163l1-0.1v-0.1c-0.3-0.3-0.6-0.6-0.8-1c-0.2-0.4-0.3-0.8-0.3-1.2
				c0-0.5,0.1-1,0.3-1.3c0.2-0.3,0.6-0.6,1-0.7c-0.4-0.3-0.7-0.7-0.9-1.1c-0.2-0.4-0.4-0.8-0.4-1.3c0-0.8,0.3-1.3,0.8-1.7
				c0.5-0.4,1.2-0.6,2.2-0.6h4.6v1.7h-4.4c-0.6,0-1,0.1-1.3,0.3c-0.2,0.2-0.4,0.5-0.4,0.8c0,0.5,0.3,1,0.9,1.5h5.1v1.7h-4.4
				c-0.6,0-1,0.1-1.3,0.3c-0.2,0.2-0.4,0.5-0.4,0.9c0,0.5,0.3,1,0.9,1.5h5.1V164.5z"/>
			<path id="XMLID_881_" class="st305" d="M195.2,148.3c0,0.3-0.1,0.7-0.2,1c-0.2,0.3-0.4,0.7-0.7,1v0l0.8,0.1v1.4h-10.5v-1.7h2.7
				l1.2,0c-0.3-0.3-0.5-0.6-0.7-1c-0.2-0.4-0.3-0.7-0.3-1.1c0-0.5,0.1-0.9,0.3-1.2c0.2-0.4,0.4-0.7,0.7-0.9c0.3-0.2,0.7-0.4,1.2-0.6
				c0.5-0.1,1-0.2,1.5-0.2c0.6,0,1.2,0.1,1.7,0.3c0.5,0.2,0.9,0.4,1.2,0.7c0.3,0.3,0.6,0.6,0.8,1
				C195.1,147.5,195.2,147.9,195.2,148.3z M193.8,148.7c0-0.5-0.2-0.9-0.6-1.2c-0.4-0.3-1.1-0.5-1.9-0.5c-0.7,0-1.3,0.1-1.7,0.4
				c-0.4,0.2-0.6,0.7-0.6,1.2c0,0.5,0.3,1.1,0.8,1.6h3.4c0.2-0.3,0.4-0.5,0.5-0.8C193.8,149.1,193.8,148.9,193.8,148.7z"/>
			<path id="XMLID_879_" class="st305" d="M195.2,141.3c0,0.8-0.3,1.4-0.8,1.7c-0.5,0.4-1.2,0.5-2.2,0.5h-4.6v-1.7h4.4
				c0.6,0,1-0.1,1.3-0.3c0.2-0.2,0.4-0.5,0.4-0.9c0-0.3-0.1-0.6-0.2-0.8c-0.2-0.2-0.4-0.5-0.8-0.8h-5v-1.7h7.3v1.4l-1.1,0.1v0
				c0.4,0.3,0.7,0.7,0.9,1C195.1,140.4,195.2,140.8,195.2,141.3z"/>
			<path id="XMLID_877_" class="st305" d="M195.2,133.1c0,0.5-0.1,1-0.3,1.5c-0.2,0.5-0.4,0.9-0.7,1.3l-1.1-0.8
				c0.3-0.3,0.5-0.7,0.6-1s0.2-0.7,0.2-1.1c0-0.4-0.1-0.7-0.2-0.9s-0.4-0.3-0.6-0.3c-0.1,0-0.3,0-0.4,0.1c-0.1,0.1-0.2,0.2-0.3,0.4
				c-0.1,0.1-0.2,0.3-0.2,0.5c-0.1,0.2-0.2,0.4-0.2,0.6c-0.1,0.2-0.2,0.5-0.3,0.7c-0.1,0.2-0.3,0.5-0.4,0.7
				c-0.2,0.2-0.4,0.4-0.6,0.5s-0.5,0.2-0.8,0.2c-0.6,0-1.2-0.2-1.6-0.7c-0.4-0.5-0.6-1.1-0.6-2c0-0.5,0.1-1,0.3-1.4
				c0.2-0.4,0.4-0.8,0.6-1.1l1,0.8c-0.2,0.3-0.3,0.5-0.5,0.8c-0.1,0.3-0.2,0.5-0.2,0.8c0,0.4,0.1,0.6,0.2,0.8
				c0.2,0.2,0.3,0.3,0.6,0.3c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.3,0.2-0.5c0.1-0.2,0.1-0.4,0.2-0.6
				c0.1-0.2,0.2-0.5,0.3-0.7c0.1-0.2,0.3-0.5,0.4-0.7c0.2-0.2,0.4-0.4,0.6-0.5c0.2-0.1,0.5-0.2,0.9-0.2c0.3,0,0.6,0.1,0.9,0.2
				c0.3,0.1,0.5,0.3,0.7,0.5c0.2,0.2,0.4,0.5,0.5,0.9C195.2,132.3,195.2,132.7,195.2,133.1z"/>
			<path id="XMLID_875_" class="st305" d="M195.2,126.5c0,0.4-0.1,0.8-0.2,1.1c-0.1,0.3-0.3,0.5-0.5,0.7c-0.2,0.2-0.5,0.3-0.8,0.4
				c-0.3,0.1-0.7,0.1-1.1,0.1h-3.5v1h-1.3l-0.1-1.1l-2-0.2v-1.4h2v-1.9h1.4v1.9h3.5c0.9,0,1.3-0.3,1.3-1c0-0.1,0-0.3,0-0.4
				c0-0.1-0.1-0.3-0.1-0.4l1.3-0.3c0.1,0.2,0.1,0.4,0.2,0.7S195.2,126.2,195.2,126.5z"/>
			<path id="XMLID_871_" class="st305" d="M186.4,122.8c0,0.3-0.1,0.6-0.3,0.8s-0.4,0.3-0.7,0.3c-0.3,0-0.5-0.1-0.7-0.3
				c-0.2-0.2-0.3-0.5-0.3-0.8c0-0.3,0.1-0.6,0.3-0.8c0.2-0.2,0.4-0.3,0.7-0.3c0.3,0,0.5,0.1,0.7,0.3
				C186.3,122.2,186.4,122.5,186.4,122.8z M195,123.7h-7.3V122h7.3V123.7z"/>
			<path id="XMLID_868_" class="st305" d="M195.2,116.2c0,0.3-0.1,0.7-0.2,1c-0.2,0.3-0.4,0.7-0.7,1v0l0.8,0.1v1.4h-10.5V118h2.7
				l1.2,0c-0.3-0.3-0.5-0.6-0.7-1c-0.2-0.4-0.3-0.7-0.3-1.1c0-0.5,0.1-0.9,0.3-1.2c0.2-0.4,0.4-0.7,0.7-0.9c0.3-0.2,0.7-0.4,1.2-0.6
				c0.5-0.1,1-0.2,1.5-0.2c0.6,0,1.2,0.1,1.7,0.3c0.5,0.2,0.9,0.4,1.2,0.7c0.3,0.3,0.6,0.6,0.8,1
				C195.1,115.4,195.2,115.8,195.2,116.2z M193.8,116.6c0-0.5-0.2-0.9-0.6-1.2c-0.4-0.3-1.1-0.5-1.9-0.5c-0.7,0-1.3,0.1-1.7,0.4
				c-0.4,0.2-0.6,0.7-0.6,1.2c0,0.5,0.3,1.1,0.8,1.6h3.4c0.2-0.3,0.4-0.5,0.5-0.8C193.8,117,193.8,116.8,193.8,116.6z"/>
			<path id="XMLID_866_" class="st305" d="M195.2,109.7c0,0.6-0.2,1-0.6,1.3c-0.4,0.2-0.9,0.4-1.5,0.4h-8.7v-1.7h8.7
				c0.2,0,0.4,0,0.4-0.1c0.1-0.1,0.1-0.2,0.1-0.3c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.2l1.3-0.2C195.2,109,195.2,109.3,195.2,109.7z"/>
			<path id="XMLID_863_" class="st305" d="M195.2,104.2c0,0.5-0.1,1-0.3,1.4c-0.2,0.4-0.4,0.8-0.8,1.1c-0.3,0.3-0.7,0.6-1.2,0.8
				c-0.5,0.2-1,0.3-1.6,0.3c-0.6,0-1.1-0.1-1.6-0.3c-0.5-0.2-0.9-0.4-1.2-0.8c-0.3-0.3-0.6-0.7-0.8-1.1c-0.2-0.4-0.3-0.8-0.3-1.3
				c0-0.5,0.1-0.9,0.3-1.3c0.2-0.4,0.4-0.7,0.7-0.9c0.3-0.3,0.7-0.4,1.1-0.6c0.4-0.1,0.9-0.2,1.4-0.2c0.2,0,0.3,0,0.5,0
				c0.1,0,0.3,0,0.4,0.1v4.7c0.7-0.1,1.2-0.3,1.5-0.7c0.4-0.4,0.5-0.9,0.5-1.5c0-0.3,0-0.6-0.1-0.9c-0.1-0.3-0.2-0.5-0.4-0.8
				l1.1-0.6c0.2,0.3,0.4,0.7,0.6,1.2C195.1,103.3,195.2,103.7,195.2,104.2z M190.7,106.1v-3.3c-0.6,0-1,0.1-1.3,0.4
				c-0.3,0.2-0.5,0.6-0.5,1.1c0,0.4,0.2,0.8,0.5,1.1S190.1,106.1,190.7,106.1z"/>
		</g>
	</g>
	<g id="XMLID_351_">
		<rect id="XMLID_991_" x="152.4" y="344.6" class="st227" width="73.3" height="26.2"/>
		<text transform="matrix(1 0 0 1 168.2183 355.9443)"><tspan x="0" y="0" class="st305 st104 st276">Punto </tspan><tspan x="-13.2" y="14" class="st305 st104 st276">ebullición</tspan></text>
	</g>
	<g id="XMLID_354_">
		<rect id="XMLID_995_" x="237" y="344.6" class="st227" width="48.8" height="26.2"/>
		<text transform="matrix(1 0 0 1 243.0615 355.9443)"><tspan x="0" y="0" class="st305 st104 st276">Flash </tspan><tspan x="-0.1" y="14" class="st305 st104 st276">point</tspan></text>
	</g>
	<g id="XMLID_349_">
		<rect id="XMLID_1000_" x="208.5" y="299.1" class="st227" width="73.3" height="11.6"/>
		<text transform="matrix(1 0 0 1 213.3115 310.4189)" class="st78 st104 st276">Sin llama</text>
	</g>
	<g id="XMLID_355_">
		<rect id="XMLID_1002_" x="358.9" y="344.6" class="st227" width="116" height="29.3"/>
		<text transform="matrix(1 0 0 1 394.9766 355.9434)"><tspan x="0" y="0" class="st305 st104 st276">Temp. </tspan><tspan x="-21.8" y="14" class="st305 st104 st276">Autoignición</tspan></text>
	</g>
	<g id="XMLID_358_">
		<rect id="XMLID_1005_" x="151.4" y="65" class="st227" width="42" height="11.7"/>
		<text transform="matrix(1 0 0 1 162.4761 74.1816)" class="st305 st104 st274">100%</text>
	</g>
	<g id="XMLID_139_">
		<rect id="XMLID_1010_" x="151.4" y="310.3" class="st227" width="42" height="11.7"/>
		<text transform="matrix(1 0 0 1 175.814 319.4688)" class="st305 st104 st274">0%</text>
	</g>
	<g id="XMLID_140_">
		<rect id="XMLID_1013_" x="522.2" y="318.6" class="st227" width="50.2" height="14"/>
		<text transform="matrix(1 0 0 1 522.1816 330.5527)" class="st305 st104 st277">Temp.</text>
	</g>
	<g id="XMLID_142_">
		<rect id="XMLID_1016_" x="338.8" y="324.4" class="st227" width="38.8" height="10.4"/>
		<text transform="matrix(1 0 0 1 344.5356 334.248)" class="st305 st104 st275">38°C</text>
	</g>
	<g id="XMLID_144_">
		<path id="XMLID_145_" d="M293.2,289.5l2-10.9l1.9,0.4l-1.7,9.3l4.6,0.8l-0.3,1.6L293.2,289.5z"/>
		<path id="XMLID_157_" d="M302.5,291.3c-0.4-0.1-0.6-0.2-0.8-0.5c-0.2-0.3-0.3-0.6-0.2-1c0.1-0.4,0.2-0.7,0.5-0.9
			c0.3-0.2,0.6-0.3,1-0.2c0.4,0.1,0.6,0.2,0.8,0.5c0.2,0.3,0.2,0.6,0.2,1c-0.1,0.4-0.2,0.7-0.5,0.9
			C303.1,291.3,302.8,291.4,302.5,291.3z"/>
		<path id="XMLID_171_" d="M306.2,291.8l2-10.9l1.9,0.4l-2,10.9L306.2,291.8z"/>
		<path id="XMLID_360_" d="M311.8,293c-0.4-0.1-0.6-0.2-0.8-0.5c-0.2-0.3-0.3-0.6-0.2-1c0.1-0.4,0.2-0.7,0.5-0.9
			c0.3-0.2,0.6-0.3,1-0.2c0.4,0.1,0.6,0.2,0.8,0.5s0.3,0.6,0.2,1c-0.1,0.4-0.2,0.7-0.5,0.9C312.5,293,312.1,293.1,311.8,293z"/>
		<path id="XMLID_362_" d="M315.5,293.5l2-10.9l1.9,0.4l-2,10.9L315.5,293.5z"/>
		<path id="XMLID_370_" d="M321.1,294.7c-0.4-0.1-0.6-0.2-0.8-0.5c-0.2-0.3-0.3-0.6-0.2-1c0.1-0.4,0.2-0.7,0.5-0.9
			c0.3-0.2,0.6-0.3,1-0.2c0.4,0.1,0.6,0.2,0.8,0.5s0.2,0.6,0.2,1c-0.1,0.4-0.2,0.7-0.5,0.9C321.8,294.7,321.5,294.8,321.1,294.7z"/>
	</g>
</g>
</svg>

    </div>
</template>

<script>
import nextConditions from "../../../js/mixins/nextConditions";
export default {
    mixins: [nextConditions],
    data() {
        return {
            visto: false,
            modala: false,
        }
    },
  methods: {
    },
    mounted() {
    },
}
</script>


<style lang="scss" scoped>
	.st0{fill:none;stroke:url(#XMLID_2474_);stroke-width:2;stroke-miterlimit:10;}
	.st1{fill:#46535B;}
	.st2{fill:none;stroke:url(#XMLID_2432_);stroke-miterlimit:10;}
	.st3{fill:none;stroke:url(#XMLID_2479_);stroke-width:2;stroke-miterlimit:10;}
	.st4{fill:none;stroke:url(#XMLID_2435_);stroke-miterlimit:10;}
	.st5{fill:none;stroke:url(#XMLID_2700_);stroke-width:6;stroke-miterlimit:10;}
	.st6{fill:#ABBFC6;}
	.st7{fill:#AC7B63;}
	.st8{font-family:'FontBase-Bold';}
	.st9{fill:#105477;}
	.st10{fill:#106489;}
	.st11{fill:none;stroke:#23CAD9;stroke-width:0.5;stroke-miterlimit:10;}
	.st12{fill:#E0B192;}
	.st13{fill:#E0E2DE;}
	.st14{fill:none;stroke:#353535;stroke-width:2;stroke-miterlimit:10;}
	.st15{fill:#132C33;}
	.st16{fill:#E1E1E1;}
	.st17{clip-path:url(#XMLID_111_);}
	.st18{fill:none;stroke:url(#XMLID_2676_);stroke-width:6;stroke-miterlimit:10;}
	.st19{fill:url(#XMLID_2442_);stroke:#232323;stroke-miterlimit:10;}
	.st20{fill:none;stroke:url(#XMLID_2679_);stroke-width:6;stroke-miterlimit:10;}
	.st21{fill:url(#XMLID_2591_);stroke:#383838;stroke-miterlimit:10;}
	.st22{fill:#32ADF0;stroke:#32ADF0;stroke-width:11;stroke-miterlimit:10;}
	.st23{fill:none;stroke:#1D1D1B;stroke-miterlimit:10;}
	.st24{clip-path:url(#XMLID_3061_);}
	.st25{clip-path:url(#XMLID_3094_);}
	.st26{fill:url(#XMLID_2630_);stroke:#383838;stroke-miterlimit:10;}
	.st27{fill:#4C4C4C;}
	.st28{fill:#E89C2E;}
	.st29{fill:#E8B897;}
	.st30{fill:url(#XMLID_2639_);stroke:#383838;stroke-miterlimit:10;}
	.st31{filter:url(#Adobe_OpacityMaskFilter);}
	.st32{fill:none;stroke:url(#XMLID_2493_);stroke-width:2;stroke-miterlimit:10;}
	.st33{fill:none;stroke:url(#XMLID_2496_);stroke-width:2;stroke-miterlimit:10;}
	.st34{fill:#B0D882;}
	.st35{fill:none;stroke:url(#XMLID_2688_);stroke-width:6;stroke-miterlimit:10;}
	.st36{fill:none;stroke:url(#XMLID_2689_);stroke-width:6;stroke-miterlimit:10;}
	.st37{fill:none;stroke:url(#XMLID_2861_);stroke-width:5;stroke-miterlimit:10;}
	.st38{fill:none;stroke:url(#XMLID_3040_);stroke-width:4;stroke-miterlimit:10;}
	.st39{fill:none;stroke:url(#XMLID_2863_);stroke-width:5;stroke-miterlimit:10;}
	.st40{fill:none;stroke:url(#XMLID_2866_);stroke-width:5;stroke-miterlimit:10;}
	.st41{fill:none;stroke:url(#XMLID_2728_);stroke-width:6;stroke-miterlimit:10;}
	.st42{fill:#B4754D;}
	.st43{fill:url(#XMLID_2640_);stroke:#383838;stroke-miterlimit:10;}
	.st44{fill:#28F7D1;stroke:#23CAD9;stroke-width:0.5;stroke-miterlimit:10;}
	.st45{fill:#B4B4B4;}
	.st46{fill:#B50D3D;}
	.st47{opacity:0.17;fill:#1D1D1B;}
	.st48{fill:#B5B5B5;}
	.st49{fill:none;stroke:#32ADF0;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:9.0305,5.644;}
	.st50{fill:#B7B7B7;}
	.st51{fill:#1D1D1B;}
	.st52{fill:#B8BAB5;}
	.st53{fill:url(#XMLID_2441_);stroke:#383838;stroke-miterlimit:10;}
	.st54{fill:none;stroke:url(#XMLID_2870_);stroke-width:5;stroke-miterlimit:10;}
	.st55{fill:#EDEDED;}
	.st56{fill:#505154;}
	.st57{fill:url(#XMLID_2445_);stroke:#383838;stroke-miterlimit:10;}
	.st58{fill:none;stroke:url(#XMLID_2430_);stroke-width:4;stroke-miterlimit:10;}
	.st59{fill:#513B1E;}
	.st60{fill:url(#XMLID_2448_);stroke:#383838;stroke-miterlimit:10;}
	.st61{fill:#EF5A24;}
	.st62{fill:#EF8425;}
	.st63{fill:none;stroke:#969696;stroke-miterlimit:10;}
	.st64{fill:#544733;}
	.st65{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}
	.st66{fill:#54D354;}
	.st67{fill:none;stroke:url(#XMLID_2502_);stroke-width:5;stroke-miterlimit:10;}
	.st68{fill:#555555;}
	.st69{fill:#555D60;}
	.st70{fill:none;stroke:url(#XMLID_2504_);stroke-width:5;stroke-miterlimit:10;}
	.st71{fill:none;stroke:url(#XMLID_2505_);stroke-width:5;stroke-miterlimit:10;}
	.st72{fill:#56361A;}
	.st73{fill:#BAC8D1;}
	.st74{fill:#F9385D;stroke:#23CAD9;stroke-width:0.5;stroke-miterlimit:10;}
	.st75{fill:#BB8062;}
	.st76{fill:#C7EE95;stroke:#23CAD9;stroke-width:0.5;stroke-miterlimit:10;}
	.st77{opacity:0.58;fill:#FFFFFF;}
	.st78{fill:#232323;}
	.st79{fill:#2368D9;}
	.st80{fill:#23CAD9;}
	.st81{fill:url(#XMLID_2486_);stroke:#232323;stroke-miterlimit:10;}
	.st82{fill:#F4C4A4;}
	.st83{opacity:0.4;fill:#1D1D1B;}
	.st84{fill:url(#XMLID_2521_);stroke:#232323;stroke-miterlimit:10;}
	.st85{fill:#28F7D1;}
	.st86{fill:none;stroke:#32ADF0;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:8.5477,5.3423;}
	.st87{fill:#F7F7F7;}
	.st88{fill:#F7F8F9;}
	.st89{fill:none;stroke:#32ADF0;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:7.6408,4.7755;}
	.st90{fill:#5E5E5E;}
	.st91{fill:#F9385D;}
	.st92{opacity:0.35;fill:#9FEDFF;}
	.st93{fill:#C07E61;}
	.st94{fill:#C12F52;}
	.st95{fill:none;stroke:#32ADF0;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:7.8706,4.9191;}
	.st96{fill:#C1A880;}
	.st97{fill:#939FA3;}
	.st98{fill:#93ADAD;}
	.st99{fill:#943B8A;}
	.st100{fill:#C3CDDD;}
	.st101{fill:url(#XMLID_2512_);stroke:#383838;stroke-miterlimit:10;}
	.st102{fill:#C54EB9;}
	.st103{fill:#2B2B2B;}
	.st104{font-family:'FontBase-SemiBold';}
	.st105{fill:url(#XMLID_2063_);}
	.st106{fill:url(#XMLID_2134_);}
	.st107{fill:url(#XMLID_2140_);}
	.st108{fill:url(#XMLID_2143_);}
	.st109{fill:url(#XMLID_2146_);}
	.st110{fill:url(#XMLID_2147_);}
	.st111{fill:url(#XMLID_2149_);}
	.st112{fill:url(#XMLID_2150_);}
	.st113{fill:#C7EE95;}
	.st114{fill:#C7F2E9;}
	.st115{fill:none;stroke:#042AB2;stroke-width:3;stroke-miterlimit:10;}
	.st116{fill:url(#XMLID_2238_);}
	.st117{fill:#99845F;}
	.st118{fill:url(#XMLID_2240_);}
	.st119{fill:url(#XMLID_2249_);}
	.st120{fill:url(#XMLID_2253_);}
	.st121{fill:none;stroke:#28F7D1;stroke-width:2;stroke-miterlimit:10;}
	.st122{fill:url(#XMLID_2355_);}
	.st123{fill:url(#XMLID_2356_);}
	.st124{fill:url(#XMLID_2357_);}
	.st125{fill:url(#XMLID_2359_);}
	.st126{fill:url(#XMLID_2374_);}
	.st127{fill:none;stroke:url(#XMLID_3090_);stroke-width:4;stroke-miterlimit:10;}
	.st128{fill:url(#XMLID_2425_);}
	.st129{fill:url(#XMLID_2426_);}
	.st130{fill:url(#XMLID_2427_);}
	.st131{fill:url(#XMLID_2485_);stroke:#383838;stroke-miterlimit:10;}
	.st132{fill:url(#XMLID_2431_);}
	.st133{fill:url(#XMLID_2436_);}
	.st134{fill:url(#XMLID_2437_);}
	.st135{fill:url(#XMLID_2438_);}
	.st136{fill:url(#XMLID_2439_);}
	.st137{fill:none;stroke:url(#XMLID_2771_);stroke-width:6;stroke-miterlimit:10;}
	.st138{fill:url(#XMLID_2440_);}
	.st139{fill:url(#XMLID_2443_);}
	.st140{fill:url(#XMLID_2444_);}
	.st141{fill:url(#XMLID_2449_);}
	.st142{fill:url(#XMLID_2480_);}
	.st143{fill:url(#XMLID_2481_);}
	.st144{fill:url(#XMLID_2482_);}
	.st145{fill:url(#XMLID_2483_);}
	.st146{fill:url(#XMLID_2484_);}
	.st147{fill:url(#XMLID_2487_);}
	.st148{fill:url(#XMLID_2488_);}
	.st149{fill:url(#XMLID_2491_);}
	.st150{fill:#FF3BCC;}
	.st151{fill:url(#XMLID_2506_);}
	.st152{fill:url(#XMLID_2507_);}
	.st153{fill:url(#XMLID_2508_);}
	.st154{fill:url(#XMLID_2509_);}
	.st155{fill:url(#XMLID_2510_);}
	.st156{fill:url(#XMLID_2511_);}
	.st157{fill:url(#XMLID_2522_);}
	.st158{fill:url(#XMLID_2523_);}
	.st159{fill:url(#XMLID_2489_);stroke:#383838;stroke-miterlimit:10;}
	.st160{fill:url(#XMLID_2534_);}
	.st161{fill:url(#XMLID_2535_);}
	.st162{fill:url(#XMLID_2536_);}
	.st163{fill:url(#XMLID_2537_);}
	.st164{fill:url(#XMLID_2539_);}
	.st165{fill:#FF7676;}
	.st166{fill:url(#XMLID_2540_);}
	.st167{fill:url(#XMLID_2543_);}
	.st168{fill:url(#XMLID_2544_);}
	.st169{fill:#FF88A4;}
	.st170{fill:url(#XMLID_2551_);}
	.st171{fill:url(#XMLID_2553_);}
	.st172{fill:url(#XMLID_2554_);}
	.st173{fill:url(#XMLID_2563_);}
	.st174{fill:url(#XMLID_2582_);}
	.st175{fill:url(#XMLID_2585_);}
	.st176{fill:#FFAF50;}
	.st177{fill:#FFB236;}
	.st178{fill:#FFC555;}
	.st179{fill:#FFC892;}
	.st180{fill:#FFD773;}
	.st181{fill:#FFEB99;}
	.st182{fill:#FFFF00;}
	.st183{fill:#FFFFFF;}
	.st184{fill:url(#XMLID_2542_);stroke:#232323;stroke-miterlimit:10;}
	.st185{fill:url(#XMLID_62_);}
	.st186{fill:url(#XMLID_2601_);}
	.st187{fill:url(#XMLID_2603_);}
	.st188{fill:url(#XMLID_2610_);}
	.st189{fill:url(#XMLID_2624_);}
	.st190{fill:url(#XMLID_2625_);}
	.st191{fill:url(#XMLID_2626_);}
	.st192{fill:url(#XMLID_2627_);}
	.st193{fill:url(#XMLID_2628_);}
	.st194{fill:url(#XMLID_2629_);}
	.st195{fill:url(#XMLID_2634_);}
	.st196{fill:url(#XMLID_2635_);}
	.st197{fill:url(#XMLID_2641_);}
	.st198{fill:url(#XMLID_2643_);}
	.st199{fill:url(#XMLID_2645_);}
	.st200{fill:url(#XMLID_2646_);}
	.st201{fill:url(#XMLID_2647_);}
	.st202{fill:url(#XMLID_2656_);}
	.st203{fill:url(#XMLID_2658_);}
	.st204{fill:url(#XMLID_2661_);}
	.st205{fill:url(#XMLID_2677_);}
	.st206{fill:url(#XMLID_2685_);}
	.st207{fill:url(#XMLID_2686_);}
	.st208{fill:url(#XMLID_2687_);}
	.st209{fill:url(#XMLID_2690_);}
	.st210{fill:url(#XMLID_2692_);}
	.st211{fill:url(#XMLID_2697_);}
	.st212{fill:url(#XMLID_2698_);}
	.st213{fill:none;stroke:#F9385D;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st214{fill:none;stroke:#F9385D;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st215{fill:url(#XMLID_2524_);stroke:#383838;stroke-miterlimit:10;}
	.st216{fill:url(#XMLID_2525_);stroke:#383838;stroke-miterlimit:10;}
	.st217{fill:url(#XMLID_2735_);}
	.st218{fill:url(#XMLID_2766_);}
	.st219{fill:none;stroke:url(#XMLID_2680_);stroke-width:4;stroke-miterlimit:10;}
	.st220{fill:url(#XMLID_2825_);}
	.st221{fill:url(#XMLID_2860_);}
	.st222{fill:url(#XMLID_2864_);}
	.st223{fill:url(#XMLID_2867_);}
	.st224{fill:url(#XMLID_2869_);}
	.st225{fill:url(#XMLID_2892_);}
	.st226{fill:url(#XMLID_2899_);}
	.st227{fill:none;}
	.st228{fill:none;stroke:url(#XMLID_2684_);stroke-width:4;stroke-miterlimit:10;}
	.st229{fill:url(#XMLID_2905_);}
	.st230{fill:url(#XMLID_2907_);}
	.st231{fill:url(#XMLID_2968_);}
	.st232{fill:#666461;}
	.st233{fill:none;stroke:url(#XMLID_2131_);stroke-width:5;stroke-miterlimit:10;}
	.st234{fill:#9A5F3E;}
	.st235{fill:none;stroke:url(#XMLID_2132_);stroke-width:5;stroke-miterlimit:10;}
	.st236{fill:url(#XMLID_2490_);stroke:#383838;stroke-miterlimit:10;}
	.st237{fill:#9BC16B;}
	.st238{fill:#68696D;}
	.st239{fill:none;stroke:url(#XMLID_2614_);stroke-width:6;stroke-miterlimit:10;}
	.st240{fill:#CCCCCC;}
	.st241{fill:#CCD8E2;}
	.st242{fill:#303233;}
	.st243{fill:none;stroke:#32ADF0;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:7.8702,4.9189;}
	.st244{fill:#28F7D1;stroke:#042AB2;stroke-width:3;stroke-miterlimit:10;}
	.st245{fill:#32ADF0;}
	.st246{fill:none;stroke:url(#XMLID_2141_);stroke-width:5;stroke-miterlimit:10;}
	.st247{fill:none;stroke:#BCBCBC;stroke-miterlimit:10;}
	.st248{fill:none;stroke:url(#XMLID_2144_);stroke-width:5;stroke-miterlimit:10;}
	.st249{fill:#353535;}
	.st250{fill:#353638;}
	.st251{fill:url(#XMLID_2541_);stroke:#383838;stroke-miterlimit:10;}
	.st252{fill:url(#XMLID_2545_);stroke:#383838;stroke-miterlimit:10;}
	.st253{fill:none;stroke:url(#XMLID_2805_);stroke-width:5;stroke-miterlimit:10;}
	.st254{fill:url(#XMLID_2546_);stroke:#383838;stroke-miterlimit:10;}
	.st255{fill:#003449;}
	.st256{fill:#004263;}
	.st257{fill:#006384;}
	.st258{fill:#006937;}
	.st259{fill:#008FB6;}
	.st260{fill:none;stroke:#042AB2;stroke-width:2;stroke-miterlimit:10;}
	.st261{fill:#020202;}
	.st262{fill:#D0D0D0;}
	.st263{fill:none;stroke:#2368D9;stroke-width:3;stroke-miterlimit:10;}
	.st264{fill:#D29472;}
	.st265{fill:#042AB2;}
	.st266{fill:none;stroke:url(#XMLID_2779_);stroke-width:5;stroke-miterlimit:10;}
	.st267{fill:url(#XMLID_107_);}
	.st268{fill:url(#XMLID_109_);}
	.st269{fill:url(#XMLID_110_);}
	.st270{fill:url(#XMLID_112_);}
	.st271{fill:url(#XMLID_113_);}
	.st272{fill:none;stroke:#32ADF0;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:8.7526,5.4704;}
	.st273{fill:#3A2914;}
	.st274{font-size:13;}
	.st275{font-size:14;}
	.st276{font-size:16;}
	.st277{font-size:17;}
	.st278{font-size:21;}
	.st279{fill:url(#XMLID_3022_);}
	.st280{fill:url(#XMLID_3024_);}
	.st281{fill:url(#XMLID_3042_);}
	.st282{fill:url(#XMLID_3043_);}
	.st283{fill:url(#XMLID_3045_);}
	.st284{fill:url(#XMLID_3046_);}
	.st285{fill:url(#XMLID_3048_);}
	.st286{fill:url(#XMLID_3049_);}
	.st287{fill:url(#XMLID_3050_);}
	.st288{fill:url(#XMLID_3055_);}
	.st289{fill:url(#XMLID_3056_);}
	.st290{fill:url(#XMLID_3062_);}
	.st291{fill:url(#XMLID_3063_);}
	.st292{fill:url(#XMLID_3064_);}
	.st293{fill:url(#XMLID_3066_);}
	.st294{fill:url(#XMLID_3067_);}
	.st295{fill:url(#XMLID_3078_);}
	.st296{fill:url(#XMLID_3082_);}
	.st297{fill:url(#XMLID_3083_);}
	.st298{fill:url(#XMLID_3084_);}
	.st299{fill:url(#XMLID_3087_);}
	.st300{fill:url(#XMLID_3088_);}
	.st301{fill:url(#XMLID_3089_);}
	.st302{fill:url(#XMLID_3092_);}
	.st303{fill:none;stroke:#686868;stroke-miterlimit:10;}
	.st304{fill:url(#XMLID_454_);}
	.st305{fill:#3D3D3D;}
	.st306{fill:#D82A53;}
	.st307{mask:url(#XMLID_2248_);}
	.st308{mask:url(#XMLID_2254_);}
	.st309{fill:none;stroke:#32ADF0;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:7.289,4.5557;}
	.st310{fill:#707070;}
	.st311{fill:none;stroke:url(#XMLID_2642_);stroke-width:6;stroke-miterlimit:10;}
	.st312{mask:url(#XMLID_2358_);}
	.st313{mask:url(#XMLID_2375_);}
	.st314{fill:none;stroke:url(#XMLID_2644_);stroke-width:6;stroke-miterlimit:10;}
	.st315{clip-path:url(#XMLID_2501_);}
	.st316{clip-path:url(#XMLID_2503_);}
	.st317{fill:none;stroke:url(#XMLID_2648_);stroke-width:6;stroke-miterlimit:10;}
	.st318{fill:none;stroke:url(#XMLID_2649_);stroke-width:6;stroke-miterlimit:10;}
	.st319{clip-path:url(#XMLID_2674_);}
	.st320{clip-path:url(#XMLID_2678_);}
	.st321{clip-path:url(#XMLID_2691_);}
	.st322{fill:#A2A599;}
	.st323{fill:#A2A7AC;}
	.st324{fill:none;stroke:#28F7D1;stroke-miterlimit:10;}
	.st325{fill:#A4704C;}
	.st326{fill:none;stroke:#32ADF0;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:8.339,5.2119;}
	.st327{fill:none;stroke:url(#XMLID_3039_);stroke-width:5;stroke-miterlimit:10;}
	.st328{fill:url(#XMLID_2606_);stroke:#383838;stroke-miterlimit:10;}
	.st329{fill:url(#XMLID_2608_);stroke:#383838;stroke-miterlimit:10;}
	.st330{fill:#DA9571;}
	.st331{fill:#DB6812;}
	.st332{fill:#0D1F30;}
	.st333{fill:none;stroke:#545454;stroke-width:3;stroke-miterlimit:10;}
	.st334{fill:#A8A8A8;}
	.st335{fill:#DCFFF8;}
	.st336{fill:none;stroke:#23CAD9;stroke-miterlimit:10;}
	.st337{fill:none;stroke:url(#XMLID_2500_);stroke-width:2;stroke-miterlimit:10;}
	.st338{fill:#0F0F0F;}
	.st339{fill:#0F4B63;}
	.st340{fill:#DDE5ED;}
	.st341{fill:url(#XMLID_2597_);stroke:#232323;stroke-miterlimit:10;}
	.st342{fill:#424242;}
	.st343{fill:url(#XMLID_2632_);stroke:#232323;stroke-miterlimit:10;}
	.st344{fill:none;stroke:#32ADF0;stroke-width:2;stroke-miterlimit:10;}
	.st345{filter:url(#Adobe_OpacityMaskFilter_1_);}
	.st346{filter:url(#Adobe_OpacityMaskFilter_2_);}
	.st347{filter:url(#Adobe_OpacityMaskFilter_3_);}
	.st348{opacity:0.51;fill:#FFFFFF;enable-background:new    ;}
	.st349{fill:#444444;}
	.st350{fill:none;stroke:url(#XMLID_2473_);stroke-width:2;stroke-miterlimit:10;}
</style>